module.exports = __webpack_public_path__ + "img/82.5.COD.14778241.png";